export default __webpack_public_path__ + "icon_build_your_own.svg";